module.exports = __webpack_public_path__ + "img/ringsize.fcf4fa3.jpg";